import SideModal from "/src/components/modal/SideModal/SideModal";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import useModalHelper from "/src/components/modal/hooks/useModalHelper";
import { formatDateWithoutSeconds } from "/src/utils/dateWithoutSeconds";
import { useToastDispatchContext } from "/src/layouts/toast/context/toastContext";
import "../../TelephonyLogs.css";
import "./TelephonyLogDetailsModal.css";

const TelephonyLogDetailsModal = NiceModal.create(({ data }) => {
    const modal = useModal();
    const { onClose } = useModalHelper(modal);
    const toast = useToastDispatchContext();

    const copyShareableLink = () => {
        const url = `${location.protocol}//${location.host}${location.pathname}?call_id=${encodeURIComponent(data.call_id)}`;
        navigator.clipboard.writeText(url).then(() => {
            toast.success("Link copied", "Share this link to jump straight to this call's logs", 5000);
        });
    };

    return (
        <SideModal id={modal.id} autoClose="true" onClose={onClose} style={{ width: "550px", zIndex: "1000" }} name="telephony_log_modal">
            <div>
                <div className="button-leave" id="close_modal_container" onClick={onClose}>
                    <i id="close_modal" className="fa fa-times" aria-hidden="true"></i>
                </div>
            </div>
            <div className="telephony-log-details">
                <div className="telephony-log-details-header">
                    <h2>{data.event_type || "Telephony log"}</h2>
                    {data.call_id && (
                        <span className="telephony-log-share-link" title="Copy a shareable link filtered to this call ID"  onClick={copyShareableLink} ></span>
                    )}
                </div>

                <div className="telephony-log-details-grid">
                    <span className="label">Date</span>
                    <span>{formatDateWithoutSeconds(data.occurred_at)}</span>

                    <span className="label">Call ID</span>
                    <span>{data.call_id || "-"}</span>

                    <span className="label">From</span>
                    <span>{data.from_number || "-"}</span>

                    <span className="label">To</span>
                    <span>{data.to_number || "-"}</span>

                    <span className="label">Level</span>
                    <span className={`telephony-log-level telephony-log-level--${data.level}`}>{data.level}</span>

                    <span className="label">Company</span>
                    <span>{data.company_name || "-"}</span>
                </div>

                <h3>Message</h3>
                <p className="telephony-log-message">{data.message || "-"}</p>

                <h3>Context</h3>
                <pre className="telephony-log-context scrollbar">
                    {data.context && Object.keys(data.context).length ? JSON.stringify(data.context, null, 2) : "-"}
                </pre>
            </div>
        </SideModal>
    );
});

export default TelephonyLogDetailsModal;
